if (!customElements.get('gift-cart-message')) {
  customElements.define('gift-cart-message', class GiftCartMessage extends HTMLElement {
    constructor() {
      super();
      this.allowSubmit = true;
      this.$form = this.querySelector('form');
      this.$message = this.querySelector('.gift-cart-message__message');
      this.$btn = this.querySelector('.gift-cart-message__btn');
      if (this.$form && this.$message && this.$btn) {
        this.checkEditState();
        this.setupEventListeners();
      }
    }

    checkEditState() {
      if (this.$message.value && this.$message.value.length) {
        this.$message.disabled = true;
        this.$btn.innerText = 'Edit message';
        this.allowSubmit = false;
      }
    }

    toggleEditMode() {
      this.$message.disabled = false;
      this.$btn.innerText = 'Update message';
      this.allowSubmit = true;
    }

    updateCartNote() {
      this.classList.add('gift-cart-message--is-loading');
      this.$message.disabled = true;
      this.$btn.disabled = true;

      const customerNote = this.$message.value;
      const emojiRegex = /[\p{Extended_Pictographic}\uFE0F]/gu;

      let note = customerNote.replace(emojiRegex, ' ');

      if (note.length > 250) {
        note = note.slice(0, 250);
      }

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.note) {
            this.$message.value = data.note;
            this.$btn.innerText = 'Update message';
            this.classList.remove('gift-cart-message--is-loading');
            this.$btn.disabled = false;
            this.checkEditState();
          }
        });
    }

    setupEventListeners() {
      this.$form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this.allowSubmit) {
          this.updateCartNote();
        } else {
          this.toggleEditMode();
        }
      });
    }
  });
}
